"use strict";

var _regeneratorRuntime = require("/Users/arjunjain/Borderless/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _toConsumableArray = require("/Users/arjunjain/Borderless/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/toConsumableArray");

var _asyncToGenerator = require("/Users/arjunjain/Borderless/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _classCallCheck = require("/Users/arjunjain/Borderless/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/arjunjain/Borderless/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _inherits = require("/Users/arjunjain/Borderless/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _createSuper = require("/Users/arjunjain/Borderless/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createSuper");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var BigNum = require("@liskhq/bignum");

var lisk_cryptography_1 = require("@liskhq/lisk-cryptography");

var base_transaction_1 = require("./base_transaction");

var constants_1 = require("./constants");

var errors_1 = require("./errors");

var utils_1 = require("./utils");

var validation_1 = require("./utils/validation");

var PREFIX_UPVOTE = '+';
var PREFIX_UNVOTE = '-';
var MAX_VOTE_PER_ACCOUNT = 101;
var MIN_VOTE_PER_TX = 1;
var MAX_VOTE_PER_TX = 33;
exports.voteAssetFormatSchema = {
  type: 'object',
  required: ['votes'],
  properties: {
    votes: {
      type: 'array',
      minItems: MIN_VOTE_PER_TX,
      maxItems: MAX_VOTE_PER_TX,
      items: {
        type: 'string',
        format: 'signedPublicKey'
      },
      uniqueSignedPublicKeys: true
    }
  }
};

var VoteTransaction = /*#__PURE__*/function (_base_transaction_1$B) {
  _inherits(VoteTransaction, _base_transaction_1$B);

  var _super = _createSuper(VoteTransaction);

  function VoteTransaction(rawTransaction) {
    var _this;

    _classCallCheck(this, VoteTransaction);

    _this = _super.call(this, rawTransaction);
    var tx = typeof rawTransaction === 'object' && rawTransaction !== null ? rawTransaction : {};
    _this.asset = tx.asset || {};
    _this.containsUniqueData = true;
    return _this;
  }

  _createClass(VoteTransaction, [{
    key: "assetToBytes",
    value: function assetToBytes() {
      return Buffer.from(this.asset.votes.join(''), 'utf8');
    }
  }, {
    key: "prepare",
    value: function () {
      var _prepare = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(store) {
        var publicKeyObjectArray, filterArray;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                publicKeyObjectArray = this.asset.votes.map(function (pkWithAction) {
                  var publicKey = pkWithAction.slice(1);
                  return {
                    publicKey: publicKey
                  };
                });
                filterArray = [{
                  address: this.senderId
                }].concat(_toConsumableArray(publicKeyObjectArray));
                _context.next = 4;
                return store.account.cache(filterArray);

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function prepare(_x) {
        return _prepare.apply(this, arguments);
      }

      return prepare;
    }()
  }, {
    key: "verifyAgainstTransactions",
    value: function verifyAgainstTransactions(transactions) {
      var _this2 = this;

      var sameTypeTransactions = transactions.filter(function (tx) {
        return tx.senderPublicKey === _this2.senderPublicKey && tx.type === _this2.type;
      }).map(function (tx) {
        return new VoteTransaction(tx);
      });
      var publicKeys = this.asset.votes.map(function (vote) {
        return vote.substring(1);
      });
      return sameTypeTransactions.reduce(function (previous, tx) {
        var conflictingVotes = tx.asset.votes.map(function (vote) {
          return vote.substring(1);
        }).filter(function (publicKey) {
          return publicKeys.includes(publicKey);
        });

        if (conflictingVotes.length > 0) {
          return [].concat(_toConsumableArray(previous), [new errors_1.TransactionError("Transaction includes conflicting votes: ".concat(conflictingVotes.toString()), _this2.id, '.asset.votes')]);
        }

        return previous;
      }, []);
    }
  }, {
    key: "validateAsset",
    value: function validateAsset() {
      validation_1.validator.validate(exports.voteAssetFormatSchema, this.asset);
      var errors = errors_1.convertToAssetError(this.id, validation_1.validator.errors);

      if (!this.amount.eq(0)) {
        errors.push(new errors_1.TransactionError('Amount must be zero for vote transaction', this.id, '.amount', this.amount.toString(), '0'));
      }

      try {
        validation_1.validateAddress(this.recipientId);
      } catch (err) {
        errors.push(new errors_1.TransactionError('RecipientId must be set for vote transaction', this.id, '.recipientId', this.recipientId));
      }

      if (this.recipientPublicKey && this.recipientId !== lisk_cryptography_1.getAddressFromPublicKey(this.recipientPublicKey)) {
        errors.push(new errors_1.TransactionError('recipientId does not match recipientPublicKey.', this.id, '.recipientId'));
      }

      return errors;
    }
  }, {
    key: "applyAsset",
    value: function applyAsset(store) {
      var _this3 = this;

      var errors = [];
      var sender = store.account.get(this.senderId);
      var balanceError = utils_1.verifyAmountBalance(this.id, sender, this.amount, this.fee);

      if (balanceError) {
        errors.push(balanceError);
      }

      var updatedSenderBalance = new BigNum(sender.balance).sub(this.amount);
      this.asset.votes.forEach(function (actionVotes) {
        var vote = actionVotes.substring(1);
        var voteAccount = store.account.find(function (account) {
          return account.publicKey === vote;
        });

        if (!voteAccount || voteAccount && (voteAccount.username === undefined || voteAccount.username === '' || voteAccount.username === null)) {
          errors.push(new errors_1.TransactionError("".concat(vote, " is not a delegate."), _this3.id, '.asset.votes'));
        }
      });
      var senderVotes = sender.votedDelegatesPublicKeys || [];
      this.asset.votes.forEach(function (vote) {
        var action = vote.charAt(0);
        var publicKey = vote.substring(1);

        if (action === PREFIX_UPVOTE && senderVotes.includes(publicKey)) {
          errors.push(new errors_1.TransactionError("".concat(publicKey, " is already voted."), _this3.id, '.asset.votes'));
        } else if (action === PREFIX_UNVOTE && !senderVotes.includes(publicKey)) {
          errors.push(new errors_1.TransactionError("".concat(publicKey, " is not voted."), _this3.id, '.asset.votes'));
        }
      });
      var upvotes = this.asset.votes.filter(function (vote) {
        return vote.charAt(0) === PREFIX_UPVOTE;
      }).map(function (vote) {
        return vote.substring(1);
      });
      var unvotes = this.asset.votes.filter(function (vote) {
        return vote.charAt(0) === PREFIX_UNVOTE;
      }).map(function (vote) {
        return vote.substring(1);
      });
      var originalVotes = sender.votedDelegatesPublicKeys || [];
      var votedDelegatesPublicKeys = [].concat(_toConsumableArray(originalVotes), _toConsumableArray(upvotes)).filter(function (vote) {
        return !unvotes.includes(vote);
      });

      if (votedDelegatesPublicKeys.length > MAX_VOTE_PER_ACCOUNT) {
        errors.push(new errors_1.TransactionError("Vote cannot exceed ".concat(MAX_VOTE_PER_ACCOUNT, " but has ").concat(votedDelegatesPublicKeys.length, "."), this.id, '.asset.votes', votedDelegatesPublicKeys.length.toString(), MAX_VOTE_PER_ACCOUNT));
      }

      var updatedSender = Object.assign({}, sender, {
        balance: updatedSenderBalance.toString(),
        votedDelegatesPublicKeys: votedDelegatesPublicKeys
      });
      store.account.set(updatedSender.address, updatedSender);
      return errors;
    }
  }, {
    key: "undoAsset",
    value: function undoAsset(store) {
      var errors = [];
      var sender = store.account.get(this.senderId);
      var updatedSenderBalance = new BigNum(sender.balance).add(this.amount);

      if (updatedSenderBalance.gt(constants_1.MAX_TRANSACTION_AMOUNT)) {
        errors.push(new errors_1.TransactionError('Invalid amount', this.id, '.amount', this.amount.toString()));
      }

      var upvotes = this.asset.votes.filter(function (vote) {
        return vote.charAt(0) === PREFIX_UPVOTE;
      }).map(function (vote) {
        return vote.substring(1);
      });
      var unvotes = this.asset.votes.filter(function (vote) {
        return vote.charAt(0) === PREFIX_UNVOTE;
      }).map(function (vote) {
        return vote.substring(1);
      });
      var originalVotes = sender.votedDelegatesPublicKeys || [];
      var votedDelegatesPublicKeys = [].concat(_toConsumableArray(originalVotes), _toConsumableArray(unvotes)).filter(function (vote) {
        return !upvotes.includes(vote);
      });

      if (votedDelegatesPublicKeys.length > MAX_VOTE_PER_ACCOUNT) {
        errors.push(new errors_1.TransactionError("Vote cannot exceed ".concat(MAX_VOTE_PER_ACCOUNT, " but has ").concat(votedDelegatesPublicKeys.length, "."), this.id, '.asset.votes', votedDelegatesPublicKeys.length.toString(), MAX_VOTE_PER_ACCOUNT));
      }

      var updatedSender = Object.assign({}, sender, {
        balance: updatedSenderBalance.toString(),
        votedDelegatesPublicKeys: votedDelegatesPublicKeys
      });
      store.account.set(updatedSender.address, updatedSender);
      return errors;
    }
  }, {
    key: "assetFromSync",
    value: function assetFromSync(raw) {
      if (!raw.v_votes) {
        return undefined;
      }

      var votes = raw.v_votes.split(',');
      return {
        votes: votes
      };
    }
  }]);

  return VoteTransaction;
}(base_transaction_1.BaseTransaction);

VoteTransaction.TYPE = 3;
VoteTransaction.FEE = constants_1.VOTE_FEE.toString();
exports.VoteTransaction = VoteTransaction;